module.exports = __webpack_public_path__ + "img/thumbnail_GiantLeafInsect_u_normal.0e9f1834.png";